import React, { useState } from 'react';
import {
  Modal,
  UiDatePicker,
  IconBtn,
  UiInput,
} from '@ru-digital-assets/ui-component';
import './redemption-date-and-reason-modal.scss';

interface IRedemptionDateModal {
  open: boolean;
  onClose: () => void;
  onSubmit: (date: Date, reason: string) => void;
}

export default function RedemptionDateAndReasonModal({
  open,
  onClose,
  onSubmit,
}: IRedemptionDateModal) {
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [reasonText, setReasonText] = useState<string>();

  return (
    <div className="redemption-date-and-reason-modal">
      <Modal
        open={open}
        onClose={onClose}
        header={<b>Укажите дату и основания прекращения обязательств</b>}
        body={
          <div>
            <p className="p p_font-size_14 mb_8">
              Дата исполнения обязательств
            </p>
            <UiDatePicker
              placeholderText="Дата"
              dateFormat="dd.MM.yyyy"
              onChangeRaw={(e: any) => e.preventDefault()}
              onChange={(date: Date) => setSelectedDate(date)}
            />
            <p className="p p_font-size_14 mb_24 mt_16">
              Настоящим уведомляю о прекращении обязательств, удостоверенных
              <br />
              токенами, на следующих основаниях:
            </p>
            <UiInput
              label="Основания прекращения обязательств"
              type="textarea"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setReasonText(e.target.value);
              }}
            />
            <div className="redemption-date-and-reason-modal__footer">
              <p className="p p_font-size_12">
                Введенные данные будут использованы при генерации
                <br />
                Заявления о прекращении обязательств
              </p>
              <div className="redemption-date-and-reason-modal__controls">
                <IconBtn onClick={onClose} outlined sm title="Отмена" />
                <IconBtn
                  onClick={() => onSubmit(selectedDate!, reasonText!)}
                  disabled={!selectedDate || !reasonText}
                  sm
                  title="Подтверждаю"
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}
